export default "__VITE_ASSET__e01936c5__"